import { useFormContext } from "react-hook-form";
import type { IAddActivityFormData } from "@/forms/AddActivityForm/AddActivityForm";
import Checkboxes from "@/components/Checkbox/Checkboxes";
import Checkbox from "@/components/Checkbox/Checkbox";
import {
  measurementsDictionary,
  orderedMeasurementsList,
} from "@medoma/models/activities";
import { useLingui } from "@lingui/react/macro";

export const MeasurementsPicker = () => {
  const {
    formState: { errors },
    register,
  } = useFormContext<IAddActivityFormData>();
  const { t } = useLingui();
  return (
    <Checkboxes
      legend={t`Värden`}
      errorMessage={errors.measurements?.message}
      orientation="horizontal"
    >
      {orderedMeasurementsList.map((measurement) => {
        return (
          <Checkbox
            key={measurement}
            label={{ text: t(measurementsDictionary[measurement]) }}
            {...register(`measurements`, {
              required: {
                value: true,
                message: t`Ange minst ett mätvärde`,
              },
            })}
            value={measurement}
            visualStyle="framed"
          />
        );
      })}
    </Checkboxes>
  );
};
